import React from 'react';
import {
  
  InputControl,
  
} from "formik-chakra-ui";

function InputText(props) {
	const {name,type,inputValue,title,placeholder} = props
	const [value, setValue] = React.useState('')
	const handleChange = (event) => setValue(event.target.value)
	return(
		<>
			<div className="field_section">
				
				 <InputControl inputProps={{...props.inputProps,placeholder}} name={name} label={title}  isRequired={props.inputProps?.isRequired}/>
				
			</div>
			
		</>
	);
}

export default InputText;